import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Box, Flex } from '@chatterbug/aaron'

const StudyGoalsSkeleton = ({
  isStacked,
  weeklyGoalSection,
  liveLessonGoalSection,
  linkSection,
  title,
  subtitle,
}) => {
  return (
    <Grid
      gridTemplateAreas={
        title
          ? `
            "TITLE TITLE"
            "SUBTITLE LINK"
            "GOALS GOALS"
          `
          : `
          "SUBTITLE LINK"
          "GOALS GOALS"
        `
      }
      gridGap="1x"
      gridTemplateColumns="repeat(2, 1fr)"
      alignItems="center"
    >
      {title && (
        <Box
          as="h2"
          variant="text.h4"
          sx={{
            gridArea:
              subtitle && title ? 'TITLE' : !subtitle ? 'SUBTITLE' : 'TITLE',
          }}
        >
          {title}
        </Box>
      )}
      <Box
        as="p"
        variant="text.h5"
        color={title && 'gray46'}
        display={subtitle ? 'block' : 'none'}
        sx={{ gridArea: 'SUBTITLE' }}
      >
        {subtitle}
      </Box>
      <Flex
        sx={{ gridArea: 'LINK' }}
        alignItems="center"
        justifyContent="flex-end"
      >
        {linkSection}
      </Flex>
      <Grid
        sx={{ gridArea: 'GOALS' }}
        gridTemplateColumns={{
          _: isStacked ? '1fr' : 'repeat(2, 1fr)',
          tablet: 'repeat(2, 1fr)',
        }}
        gridGap="2x"
        flexDirection="column"
      >
        {liveLessonGoalSection}
        {weeklyGoalSection}
      </Grid>
    </Grid>
  )
}

StudyGoalsSkeleton.propTypes = {
  weeklyGoalSection: PropTypes.any,
  liveLessonGoalSection: PropTypes.any,
  title: PropTypes.any,
  linkSection: PropTypes.any,
  subtitle: PropTypes.string,
}

export default StudyGoalsSkeleton
